import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.OpenInSourceLink', {
    openInSourceLinkText: 'Open in {integrationName}',
    editInSourceLinkText: 'Open for editing',
});
